/**
 * Normalize a URL for pin matching: drop the hash and trailing slash so pins
 * placed on the "same" page re-anchor regardless of fragment navigation.
 */
export function normalizeUrl(raw: string): string {
  try {
    const u = new URL(raw);
    u.hash = '';
    let s = u.origin + u.pathname + u.search;
    if (s.length > 1 && s.endsWith('/')) s = s.slice(0, -1);
    return s;
  } catch {
    return raw;
  }
}
